export type T_SERVICE_TRACKER_REDUCER = Record<
  string,
  'LOADING' | 'SUCCESS' | 'ERROR'
>

export const INITIAL_STATE: T_SERVICE_TRACKER_REDUCER = {}
